import React, { useState } from "react";
import '../../src/styles/QuoteForm.css';
import emailjs from 'emailjs-com'; // Ensure you have EmailJS imported

import { SERVICE_ID, TEMPLATE_ID, USER_ID } from '../App.js';

const Quote = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [product, setProduct] = useState("");
    const [quantity, setQuantity] = useState("");
    const [details, setDetails] = useState("");
    // const [setSuccessMessage] = useState(""); // State for success message

    const colletData = () => {
        const templateParams = {
            name,
            email,
            product,
            quantity,
            details,
        };

        emailjs.send(
            SERVICE_ID, // Replace with your actual Service ID
            TEMPLATE_ID, // Replace with your actual Template ID
            templateParams,
            USER_ID // Replace with your actual User ID
        )
        .then((response) => {
            console.log('SUCCESS!', response.status, response.text);
            if (response.status === 200) {
                alert("Email sent successfully");
            }
            // alert("Email sent successfully");
            // setSuccessMessage("Your message has been sent successfully!"); // Set success message
            // Reset fields
            setName("");
            setEmail("");
            setProduct("");
            setQuantity("");
            setDetails("");
        })
        .catch((err) => {
            console.log('FAILED...', err);
            alert("Email failed to send: " + JSON.stringify(err));
            // setSuccessMessage("Failed to send the message. Please try again."); // Set error message
            setName("");
            setEmail("");
            setProduct("");
            setQuantity("");
            setDetails("");
        });
    }

    return (
        <div className="quote">
            <h1>Request a Quote</h1>
            <input className="inputBox" type="text" placeholder="Enter Name"
                value={name} onChange={(e) => setName(e.target.value)}
            />
            <input className="inputBox" type="number" placeholder="Enter Phone Number"
                value={product} onChange={(e) => setProduct(e.target.value)}
            />
            <input className="inputBox" type="text" placeholder="Enter Email"
                value={email} onChange={(e) => setEmail(e.target.value)}
            />
            <input className="inputBox" type="number" placeholder="Enter Quantity"
                value={quantity} onChange={(e) => setQuantity(e.target.value)}
            />
            <textarea className="inputBoxDetails" placeholder="Additional Details"
                value={details} onChange={(e) => setDetails(e.target.value)}
            />
            <button onClick={colletData} className="quoteBtn" type="button">Send</button>
        </div>
    )
};

export default Quote;